
export const GENERIC_MESSAGE = "Une erreur est survenue. Veuillez réessayer ou utiliser un autre mode de connexion";
export const GENERIC_MAGIC_TOKEN_MESSAGE = "Une erreur est survenue avec le lien fourni. Veuillez réessayer ou utiliser un autre mode de connexion";
export const HELP_MESSAGE = "Si les informations sont incorrectes, veuillez contacter l’hôpital qui vous prend en charge" + (process.env.VUE_APP_HOSPITAL_MAIL ? " ("+process.env.VUE_APP_HOSPITAL_MAIL+").": ".");

export const LOG_AUTH_CODES = {
    FC_USER_AUTH_EXPIRED: { 
      code: "fc_user_auth_expired", 
      message: "La session d'authentification a expiré. Veuillez réessayer ou utiliser un autre mode de connexion.", 
    },
    FC_MISSING_CODE: { 
      code: "fc_missing_code", 
      message: "Aucun code d'authentification n'a été fourni. Veuillez réessayer ou utiliser un autre mode de connexion.", 
    },
    FC_ACCESS_TOKEN_ERROR: { 
      code: "fc_access_token_error", 
      message: "Problème lors de la récupération du token d'accès. Veuillez réessayer ou utiliser un autre mode de connexion.", 
    },
    FC_ID_TOKEN_EXPIRED: { 
      code: "fc_id_token_expires", 
      message: "Le token d'identification a expiré. Veuillez réessayer ou utiliser un autre mode de connexion.", 
    },
    FC_INVALID_NONCE: {  
      code: "fc_invalid_nonce", 
      message: "nonce invalide dans la réponse de FranceConnect. Veuillez réessayer ou utiliser un autre mode de connexion.",      
    },
    FC_USER_INFO_ERROR: { 
      code: "fc_user_info_error", 
      message: "Des informations incorrectes ou manquantes ont été reçues de FranceConnect. Veuillez réessayer ou utiliser un autre mode de connexion.",
    },
    FC_NO_MATCHING_USER: { 
      code: "fc_no_matching_user", 
      message: "Aucun utilisateur correspondant n'a été trouvé. Veuillez réessayer ou utiliser un autre mode de connexion.", 
    },
    IPP: {
      code: "ipp_invalid",
      message: "Vous avez dépassé le nombre d'essais autorisés. Veuillez réessayer plus tard.",
    },
    // FranceConnect possible errors
    INVALID_SCOPE: {
        code: "invalid_scope",
        message: GENERIC_MESSAGE,
    },
    INVALID_REQUEST: {
        code: "invalid_request",
        message: GENERIC_MESSAGE,
    },
    ACCESS_DENIED:{
        code: "access_denied",
        message: GENERIC_MESSAGE,
    },
    SERVER_ERROR: {
        code: "server_error",
        message: GENERIC_MESSAGE,
    },
    TEMPORARILY_UNAVAILABLE: {
        code: "temporarily_unavailable",
        message: GENERIC_MESSAGE,
    },
    MAGIC_URL_NOT_TOKEN_IN_PARAMS: {
        code: "magic_url_not_token_in_params",
        message: "Aucun token n'a été fourni dans le lien. Veuillez réessayer ou utiliser un autre mode de connexion.",
    },
    WRONG_PASSWORD: {
        code: "wrong_password",
        message: "Le mot de passe est incorrect. Veuillez réessayer.",
    },
    MAGIC_TOKEN_USER_NOT_FOUND: {
        code: "magic_token_user_not_found",
        message: "Aucun utilisateur correspondant n'a été trouvé. Veuillez réessayer ou utiliser un autre mode de connexion.",
    },
    MAGIC_TOKEN_REVOKED: {
        code: "magic_token_revoked",
        message: "Le lien n'est plus valide. Veuillez réessayer ou utiliser un autre mode de connexion.",
    },
    MAGIC_TOKEN_PAYLOAD_ERROR: {  
        code: "magic_token_payload_error",
        message: GENERIC_MAGIC_TOKEN_MESSAGE,
    }
};

